export enum ParentType {
  CARD = "CARD",
  CARD_REQUEST = "CARD_REQUEST",
  TRANSACTION = "TRANSACTION",
  CONTACT = "CONTACT",
  INVOICE = "INVOICE",
  PAYMENT = "PAYMENT",
}
